import { useContext } from 'react';
import BioContext from '../../store/bio-context';

const ProfilePhoto = (props) => {

    const profileData = useContext(BioContext);

    return ( 
        <img src={profileData.GeneralInfo.profilePicture} alt="profile Photo" className={props.className} width={props.width} height={props.height}/>
     );
}
 
export default ProfilePhoto;